import React, { useEffect, useState } from "react";
import { Bar, Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend } from 'chart.js';
import Navbar from "../navbar/navbar";
import FooterBar from "../footer/footerBar";
import customizeScrollbar from "customsb";
import api from "../../services/api";
import { vhostV1 } from "../funcoes";
import './dreDashboard.css';
import ModalDreContasRecebidas from "./modalDreContasRecebidas";
import ModalDreContasEmitidas from "./modalDreContasEmitidas";
import ModalDreContasPendentes from "./modalDreContasPendentes";



ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend
);


function DreDashboard() {

  const anos = [
    {valor: 2020},
    {valor: 2021},
    {valor: 2022},
    {valor: 2023},
    {valor: 2024}, 
    {valor: 2025}];


  const meses = [
    { valor: 1, descricao: "Janeiro" },
    { valor: 2, descricao: "Fevereiro" },
    { valor: 3, descricao: "Março" },
    { valor: 4, descricao: "Abril" },
    { valor: 5, descricao: "Maio" },
    { valor: 6, descricao: "Junho" },
    { valor: 7, descricao: "Julho" },
    { valor: 8, descricao: "Agosto" },
    { valor: 9, descricao: "Setembro" },
    { valor: 10, descricao: "Outubro" },
    { valor: 11, descricao: "Novembro" },
    { valor: 12, descricao: "Dezembro" }
  ];

  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1;  
  const currentYear = currentDate.getFullYear();


  const [contas, setContas] = useState([]);
  const [dadosGraficoOperacoes, setDadosGraficoOperacoes] = useState({
    labels: [],
    datasets: []
  });
  const [totalOperacoes, setTotalOperacoes] = useState(0);
  const [totalPago, setTotalPago] = useState(0);
  const [totalPendente, setTotalPendente] = useState(0);
  const [tipoRelatorio, setTipoRelatorio] = useState('M'); 
  const [mesSelecionado, setMesSelecionado] = useState(currentMonth);
  const [anoSelecionado, setAnoSelecionado] = useState(currentYear);
  const [contasRecebidasRel, setContasRecebidasRel] = useState([]);
  const [isModalRecebidasOpen, setIsModalRecebidasOpen] = useState(false);
  const [isModalEmitidasOpen, setIsModalEmitidasOpen] = useState(false);
  const [isModalPendentesOpen, setIsModalPendentesOpen] = useState(false);
  const [contasEmitidasRel, setContasEmitidasRel] = useState([]);
  const [contasPendentesRel, setContasPendentesRel] = useState([]);
  const [dadosGraficoFinalizadoras, setDadosGraficoFinalizadoras] = useState({ labels: [], datasets: [] });
  const [labelsFinalizadora, setLabelsFinalizadora] = useState([]); 
  const [dataFinalizadora, setDataFinalizadora] = useState([]);
  const [colors, setColors] = useState({});
  const [totalVendas, setTotalVendas] = useState(0);
  const [ticketMedio, setTicketMedio] = useState(0);
  const [dadosGraficoPromissorias, setDadosGraficoPromissorias] = useState({ labels: [], datasets: [] });
  const [totalPromissorias, setTotalPromissorias] = useState(0);
  const [totalPromissoriasPago, setTotalPromissoriasPago] = useState(0);
  const [totalPromissoriasPendente, setTotalPromissoriasPendente] = useState(0);
  const [dataPromissorias, setDataPromissorias] = useState([]);
  

  useEffect(() => {
    
    customizeScrollbar({
      scrollbarWidth: "10px",
      trackBackground: "#333",
      thumbBackground:
        "linear-gradient(178.8deg, #ffa066 47.41%, #ff9666 65.18%, #ff783a 90.84%)",
      thumbBorderRadius: "10px",
    });
  }, []);

  let config = {
    headers: {
       'Authorization': localStorage.getItem("token")
       }
    }

    useEffect(()=> {
      api.post(vhostV1('webcash/contas/resultado/contasReceber/historicoContaRecebidas'),{
        loja: localStorage.getItem('loja'),
        ano: Number(anoSelecionado),
        mes: Number(mesSelecionado),
      },config)
      .then(function(response) {
        
          setContasRecebidasRel(response.data.dados);
          console.log(response);
      }).catch(function(error){
        console.log(error);
      })
    },[anoSelecionado, mesSelecionado]);

    const openModalRecebidas = () => {
      setIsModalRecebidasOpen(true);
  };

  const closeModalRecebidas = () => {
      setIsModalRecebidasOpen(false);
  };

  useEffect(()=> {
    api.post(vhostV1('webcash/contas/resultado/contasReceber/historicoContasEmitidas'),{
      loja: localStorage.getItem('loja'),
      ano: Number(anoSelecionado),
      mes: Number(mesSelecionado),
    },config)
    .then(function(response) {
      
        setContasEmitidasRel(response.data.dados);
        console.log(response.data.dados);
    }).catch(function(error){
      console.log(error);
    })
  },[anoSelecionado, mesSelecionado]);

  const openModalEmitidas = () => {
    setIsModalEmitidasOpen(true);
};

const closeModalEmitidas = () => {
    setIsModalEmitidasOpen(false);
};


useEffect(()=> {
  api.post(vhostV1('webcash/contas/resultado/contasReceber/historicoContaNaoRecebidas'),{
    loja: localStorage.getItem('loja'),
    ano: Number(anoSelecionado),
    mes: Number(mesSelecionado),
  },config)
  .then(function(response) {
    
      setContasPendentesRel(response.data.dados);
      console.log(response.data.dados);
  }).catch(function(error){
    console.log(error);
  })
},[anoSelecionado, mesSelecionado]);

console.log(contasPendentesRel);


const openModalPendentes = () => {
  setIsModalPendentesOpen(true);
};

const closeModalPendentes = () => {
  setIsModalPendentesOpen(false);
};

useEffect(() => {
  const fetchData = async () => {
    let totalOperacoes = 0;
    let totalPago = 0;
    let totalPendente = 0;
    let totalVendasTemp = 0;
    let quantidadeVendas = 0;

    const labels = tipoRelatorio === 'M'
      ? Array.from({ length: new Date(anoSelecionado, mesSelecionado, 0).getDate() }, (_, i) => `Dia ${i + 1}`)
      : ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    
    const dadosGraficoTemp = {
      labels: labels,
      datasets: [],
    };

    if (tipoRelatorio === 'M') {
      try {
        const response = await api.post(vhostV1('webcash/dashboard/vendaFinalizadoraPorDia'), {
          loja: localStorage.getItem("loja"),
          ano: Number(anoSelecionado),
          mes: Number(mesSelecionado),
        }, config);

        console.log(response);

        const data = response.data.dados || [];
        setDataFinalizadora(data);

        if (!Array.isArray(data) || data.length === 0) {
          setDadosGraficoFinalizadoras(dadosGraficoTemp);
          setTotalVendas(0);
          return;
        }

       
        data.forEach((dado) => {
          if (!dado || !dado.DATA || !dado.FINALIZADORA || dado.VALOR_FINAL == null) return; 

          const diaNumero = new Date(dado.DATA).getDate() - 1;
          const datasetIndex = dadosGraficoTemp.datasets.findIndex((dataset) => dataset.label === dado.FINALIZADORA);

          if (datasetIndex === -1) {
            dadosGraficoTemp.datasets.push({
              label: dado.FINALIZADORA,
              backgroundColor: getRandomColor(),
              data: Array(labels.length).fill(0),
            });
          }

          dadosGraficoTemp.datasets.forEach((dataset) => {
            if (dataset.label === dado.FINALIZADORA) {
              dataset.data[diaNumero] += dado.VALOR_FINAL;
            }
          });

          
          totalVendasTemp += dado.VALOR_FINAL;
          quantidadeVendas += dado.QUANTIDADE_REGISTROS;
        });

       
        setDadosGraficoFinalizadoras(dadosGraficoTemp);
        setTotalVendas(totalVendasTemp);
        setTicketMedio(totalVendasTemp / quantidadeVendas);

      } catch (error) {
        console.error(error);
      }
    } else if (tipoRelatorio === 'A') {
      try {
        
        const promises = Array.from({ length: 12 }, (_, i) =>
          api.post(vhostV1('webcash/dashboard/vendaFinalizadoraPorDia'), {
            loja: localStorage.getItem("loja"),
            ano: Number(anoSelecionado),
            mes: i + 1,
          }, config)
        );

        const responses = await Promise.all(promises);
        const allData = responses.map(response => response.data.dados || []); 

        const dadosGraficoTemp = {
          labels: labels,
          datasets: [],
        };

        allData.forEach((data, monthIndex) => {
          if (!Array.isArray(data)) return; 

          data.forEach((dado) => {
            if (!dado || !dado.FINALIZADORA || dado.VALOR_FINAL == null) return; 

            const datasetIndex = dadosGraficoTemp.datasets.findIndex((dataset) => dataset.label === dado.FINALIZADORA);

            if (datasetIndex === -1) {
              dadosGraficoTemp.datasets.push({
                label: dado.FINALIZADORA,
                backgroundColor: getRandomColor(),
                data: Array(12).fill(0),
              });
            }

            dadosGraficoTemp.datasets.forEach((dataset) => {
              if (dataset.label === dado.FINALIZADORA) {
                dataset.data[monthIndex] += dado.VALOR_FINAL;
              }
            });

           
            totalVendasTemp += dado.VALOR_FINAL;
            quantidadeVendas += dado.QUANTIDADE_REGISTROS;
          });
        });

       
        setDadosGraficoFinalizadoras(dadosGraficoTemp);
        setTotalVendas(totalVendasTemp);
        setTicketMedio(totalVendasTemp / quantidadeVendas);
      } catch (error) {
        console.error(error);
      }
    }
  };

  fetchData();
}, [anoSelecionado, mesSelecionado, tipoRelatorio]);


const getRandomColor = () => {
  const letters = '0123456789ABCDEF';
  let color = '#';
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

useEffect(() => {
  const fetchData = async () => {
    let totalPromissoes = 0;
    let totalPago = 0;
    let totalPendente = 0;
    let quantidadePromissoes = 0;

    const labels = tipoRelatorio === 'M'
      ? Array.from({ length: new Date(anoSelecionado, mesSelecionado, 0).getDate() }, (_, i) => `Dia ${i + 1}`)
      : ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];

    const dadosGraficoTemp = {
      labels: labels,
      datasets: [],
    };

    if (tipoRelatorio === 'M') {
      try {
        const response = await api.post(vhostV1('webcash/dashboard/promissorias'), {
          loja: localStorage.getItem("loja"),
          ano: Number(anoSelecionado),
          mes: Number(mesSelecionado),
        }, config);

        console.log(response);

        const data = response.data.dados || [];
        setDataPromissorias(data);

        if (!Array.isArray(data) || data.length === 0) {
          setDadosGraficoPromissorias(dadosGraficoTemp);
          setTotalPromissorias(0);
          return;
        }

        data.forEach((dado) => {
          if (!dado || !dado.DATA_EMISSAO || dado.VALOR == null || !dado.STATUS) return;

          const diaNumero = new Date(dado.DATA_EMISSAO).getDate() - 1;
          const status = dado.STATUS.trim();

          // Define cores fixas para os status
          const cor = status === 'PAGO' ? '#00FF00' : (status === 'PENDENTE' ? '#FF6347' : null);
          
          // Verifica se já existe um dataset para o status
          const datasetIndex = dadosGraficoTemp.datasets.findIndex((dataset) => dataset.label === status);

          if (datasetIndex === -1) {
            dadosGraficoTemp.datasets.push({
              label: status,
              backgroundColor: cor, // Aplica a cor fixa
              data: Array(labels.length).fill(0),
            });
          }

          // Adiciona o valor à data correspondente
          dadosGraficoTemp.datasets.forEach((dataset) => {
            if (dataset.label === status) {
              dataset.data[diaNumero] += dado.VALOR;
            }
          });

          // Atualiza os totais
          totalPromissoes += dado.VALOR;
          if (status === 'PAGO') totalPago += dado.VALOR;
          if (status === 'PENDENTE') totalPendente += dado.VALOR;
          quantidadePromissoes += dado.QNTD_PROMISSORIA;
        });

        setDadosGraficoPromissorias(dadosGraficoTemp);
        setTotalPromissorias(totalPromissoes);
        setTotalPromissoriasPago(totalPago);
        setTotalPromissoriasPendente(totalPendente);

      } catch (error) {
        console.error(error);
      }
    } else if (tipoRelatorio === 'A') {
      try {
        const promises = Array.from({ length: 12 }, (_, i) =>
          api.post(vhostV1('webcash/dashboard/promissorias'), {
            loja: localStorage.getItem("loja"),
            ano: Number(anoSelecionado),
            mes: i + 1,
          }, config)
        );

        const responses = await Promise.all(promises);
        const allData = responses.map(response => response.data.dados || []);

        const dadosGraficoTemp = {
          labels: labels,
          datasets: [],
        };

        allData.forEach((data, monthIndex) => {
          if (!Array.isArray(data)) return;

          data.forEach((dado) => {
            if (!dado || !dado.DATA_EMISSAO || dado.VALOR == null || !dado.STATUS) return;

            const status = dado.STATUS.trim();

            // Define cores fixas para os status
            const cor = status === 'PAGO' ? '#00FF00' : (status === 'PENDENTE' ? '#FF6347' : null);

            // Verifica se já existe um dataset para o status
            const datasetIndex = dadosGraficoTemp.datasets.findIndex((dataset) => dataset.label === status);

            if (datasetIndex === -1) {
              dadosGraficoTemp.datasets.push({
                label: status,
                backgroundColor: cor, // Aplica a cor fixa
                data: Array(12).fill(0),
              });
            }

            // Adiciona o valor ao dataset correspondente ao mês
            dadosGraficoTemp.datasets.forEach((dataset) => {
              if (dataset.label === status) {
                dataset.data[monthIndex] += dado.VALOR;
              }
            });

            // Atualiza os totais
            totalPromissoes += dado.VALOR;
            if (status === 'PAGO') totalPago += dado.VALOR;
            if (status === 'PENDENTE') totalPendente += dado.VALOR;
            quantidadePromissoes += dado.QNTD_PROMISSORIA;
          });
        });

        setDadosGraficoPromissorias(dadosGraficoTemp);
        setTotalPromissorias(totalPromissoes);
        setTotalPromissoriasPago(totalPago);
        setTotalPromissoriasPendente(totalPendente);

      } catch (error) {
        console.error(error);
      }
    }
  };

  fetchData();
}, [anoSelecionado, mesSelecionado, tipoRelatorio]);

const optionsGraficoFinalizadoras = {
  responsive: true,
  plugins: {
    legend: { display: true },
    tooltip: {
      mode: 'index',
      intersect: false,
      callbacks: {
        label: (context) => {
          const datasetIndex = context.datasetIndex;
          const dataIndex = context.dataIndex;
          const valorFinalizadora = context.chart.data.datasets[datasetIndex].data[dataIndex];
          return `${context.chart.data.datasets[datasetIndex].label}: R$ ${valorFinalizadora.toFixed(2).replace('.', ',')}`;
        },
        footer: (tooltipItems) => {
          const totalDia = tooltipItems.reduce((total, item) => {
            return total + item.raw;
          }, 0);

          return `Total: R$ ${totalDia.toFixed(2).replace('.', ',')}`;
        },
      },
    },
    datalabels: {
      align: 'center',
      anchor: 'center',
      color: 'white',
      font: { weight: 'bold' },
      formatter: (value) => `R$ ${value.toFixed(2)}`,
    },
  },
  scales: {
    x: { stacked: true },
    y: { stacked: true },
  },
};

    useEffect(() => {
      const fetchData = async () => {
        let totalOperacoes = 0;
        let totalPago = 0;
        let totalPendente = 0;
        
        const labels = tipoRelatorio === 'M' ? 
          Array.from({ length: new Date(anoSelecionado, mesSelecionado, 0).getDate() }, (_, i) => `Dia ${i + 1}`) : 
          ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'];
      
        const dadosGrafico = {
          labels: labels,
          datasets: [
            {
              label: 'Contas Recebidas',
              backgroundColor: '#00FF00',
              data: Array(labels.length).fill(0),
            },
            {
              label: 'Contas Não Recebidas',
              backgroundColor: '#FF6347',
              data: Array(labels.length).fill(0),
            },
            {
              label: 'Total de Contas Emitidas',
              backgroundColor: '#007FFF',
              data: Array(labels.length).fill(0),
            },
          ],
        };
      
        if (tipoRelatorio === 'M') {
          try {
            const response = await api.post(vhostV1('webcash/contas/resultado/contasReceber'), {
              loja: localStorage.getItem("loja"),
              ano: Number(anoSelecionado),
              mes: Number(mesSelecionado),
            }, config);

            
      
            const data = response.data.dados;
            setContas(data);
      
            if (data.length === 0 || data === undefined) {
           
              setTotalOperacoes(0);
              setTotalPago(0);
              setTotalPendente(0);
              setDadosGraficoOperacoes(dadosGrafico);
              return;
            }
      
            data.forEach((dado) => {
              totalOperacoes += dado.todasAsContas;
              totalPago += dado.todasAsContasRecebidas;
              totalPendente += dado.contasNaoRecebidas;
            });
      
            data.forEach((dado) => {
              const diaNumero = dado.dia - 1;
              dadosGrafico.datasets[0].data[diaNumero] = dado.todasAsContasRecebidas;
              dadosGrafico.datasets[1].data[diaNumero] = dado.contasNaoRecebidas;
              dadosGrafico.datasets[2].data[diaNumero] = dado.todasAsContas;
            });
      
            setTotalOperacoes(totalOperacoes);
            setTotalPago(totalPago);
            setTotalPendente(totalPendente);
            setDadosGraficoOperacoes(dadosGrafico);
      
          } catch (error) {
            console.log(error);
          }
        } else if (tipoRelatorio === 'A') {
          try {
            const promises = Array.from({ length: 12 }, (_, i) =>
              api.post(vhostV1('webcash/contas/resultado/contasReceber'), {
                loja: localStorage.getItem("loja"),
                ano: Number(anoSelecionado),
                mes: i + 1,
              }, config)
            );
      
            const responses = await Promise.all(promises);
            const allData = responses.map(response => response.data.dados);
      
            if (allData.length === 0) {
              
              setTotalOperacoes(0);
              setTotalPago(0);
              setTotalPendente(0);
              setDadosGraficoOperacoes(dadosGrafico);
              return;
            }
      
            allData.forEach((data, monthIndex) => {
              data.forEach((dado) => {
                totalOperacoes += dado.todasAsContas;
                totalPago += dado.todasAsContasRecebidas;
                totalPendente += dado.contasNaoRecebidas;
      
                dadosGrafico.datasets[0].data[monthIndex] += dado.todasAsContasRecebidas;
                dadosGrafico.datasets[1].data[monthIndex] += dado.contasNaoRecebidas;
                dadosGrafico.datasets[2].data[monthIndex] += dado.todasAsContas;
              });
            });
      
            setTotalOperacoes(totalOperacoes);
            setTotalPago(totalPago);
            setTotalPendente(totalPendente);
            setDadosGraficoOperacoes(dadosGrafico);
      
          } catch (error) {
            console.log(error);
          }
        }
      };
    
      fetchData();
    }, [mesSelecionado, anoSelecionado, tipoRelatorio]);
    
  
  const handleTipoRelatorioChange = (event) => {
    setTipoRelatorio(event.target.value);
  };

  
  const handleMesChange = (event) => {
    setMesSelecionado(event.target.value);
  };

  const handleAnoChange = (event) => {
    setAnoSelecionado(event.target.value);
  };


    
        const options = {
          responsive: true,
          plugins: {
            legend: { display: true },
            tooltip: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: (context) => {
                  const datasetIndex = context.datasetIndex;
                  const dataIndex = context.dataIndex;
        
                  const datasets = context.chart.data.datasets;
        
                 
                  const contasRecebidas = datasets[0] ? datasets[0].data[dataIndex] : 0;
                  const contasNaoRecebidas = datasets[1] ? datasets[1].data[dataIndex] : 0;
                  const totalContas = datasets[2] ? datasets[2].data[dataIndex] : 0;
        
                 
                  if (datasetIndex === 0) {
                    return `R$: ${contasRecebidas.toFixed(2).replace('.', ',')}`;
                  } else if (datasetIndex === 1) {
                    return `R$: ${contasNaoRecebidas.toFixed(2).replace('.', ',')}`;
                  } else if (datasetIndex === 2) {
                    return `R$: ${totalContas.toFixed(2).replace('.', ',')}`;
                  }
                },
                footer: (tooltipItems) => {
                  const contasRecebidas = tooltipItems[0] ? tooltipItems[0].parsed.y : 0;
                  const contasNaoRecebidas = tooltipItems[1] ? tooltipItems[1].parsed.y : 0;
                  const totalContas = tooltipItems[2] ? tooltipItems[2].parsed.y : 0;
        
                 
                  const totalDia = contasRecebidas + contasNaoRecebidas + totalContas;
        
                  
                },
              },
            },
          },
          scales: {
            x: { stacked: true },
            y: { stacked: true },
          },
        };

  

        const optionsGraficoPromissorias = {
          responsive: true,
          plugins: {
            legend: { display: true },
            tooltip: {
              mode: 'index',
              intersect: false,
              callbacks: {
                label: (context) => {
                  const datasetIndex = context.datasetIndex;
                  const dataIndex = context.dataIndex;
                  const valorFinalizadora = context.chart.data.datasets[datasetIndex].data[dataIndex];
                  return `${context.chart.data.datasets[datasetIndex].label}: R$ ${valorFinalizadora.toFixed(2).replace('.', ',')}`;
                },
                footer: (tooltipItems) => {
                  const totalDia = tooltipItems.reduce((total, item) => {
                    return total + item.raw;
                  }, 0);
        
                  return `Total: R$ ${totalDia.toFixed(2).replace('.', ',')}`;
                },
              },
            },
            datalabels: {
              align: 'center',
              anchor: 'center',
              color: 'white',
              font: { weight: 'bold' },
              formatter: (value) => `R$ ${value.toFixed(2)}`,
            },
          },
          scales: {
            x: { stacked: false }, 
            y: { stacked: false }, 
          },
        };
  

  return (
    <div>
      <Navbar />
      <div className="container-fluid titulo offset-lg-1 col-lg-10">
        <div style={{ padding: '20px' }}>
          <div className="d-flex justify-content-between">
            <div>
              <h1>SRI - DASHBOARD</h1>
            </div>
            <div className="d-flex">
              <div style={{ marginBottom: '20px' }}>
                <select className="form-select form-select-lg" onChange={handleTipoRelatorioChange} value={tipoRelatorio}>
                  <option value="M">Mensal</option>
                  <option value="A">Anual</option>
                </select>
              </div>

              {tipoRelatorio === 'A' && (
                <div style={{ marginBottom: '20px' }}>
                  <select className="form-select form-select-lg" onChange={handleAnoChange} value={anoSelecionado}>
                    {anos.map((ano) => (
                      <option key={ano.valor} value={ano.valor}>{ano.valor}</option>
                    ))}
                  </select>
                </div>
              )}

              {tipoRelatorio === 'M' && (
                <>
                  <div style={{ marginBottom: '20px' }}>
                    <select className="form-select form-select-lg" onChange={handleMesChange} value={mesSelecionado}>
                      {meses.map((mes) => (
                        <option key={mes.valor} value={mes.valor}>{mes.descricao}</option>
                      ))}
                    </select>
                  </div>
                  <div style={{ marginBottom: '20px' }}>
                    <select className="form-select form-select-lg" onChange={handleAnoChange} value={anoSelecionado}>
                      {anos.map((ano) => (
                        <option key={ano.valor} value={ano.valor}>{ano.valor}</option>
                      ))}
                    </select>
                  </div>
                </>
              )}
            </div>
          </div>

          <hr />
           <div>
           <h2>Contas a Receber</h2>
           </div>
          

           <div>
  <div className="d-flex justify-content-between mb-5">
    <div className="" style={{ width: '30%', border: '3px solid #007FFF' }}>
      <div className="card-body" id="card-totalEmitido">
        <h5 className="card-title">Total de Emissões</h5>
        <p className="card-text">{totalOperacoes}</p>
        <button onClick={openModalEmitidas} className="card-text btn">Explorar</button>
        <ModalDreContasEmitidas isOpen={isModalEmitidasOpen} onClose={closeModalEmitidas} dados={contasEmitidasRel} />
      </div>
    </div>
    <div className="" style={{ width: '30%' , border: '3px solid #00FF00' }}>
      <div className="card-body" id="card-totalPago">
        <h5 className="card-title">Total Pago</h5>
        <p className="card-text">{totalPago}</p>
        <button onClick={openModalRecebidas} className="card-text btn">Explorar</button>
        <ModalDreContasRecebidas isOpen={isModalRecebidasOpen} onClose={closeModalRecebidas} dados={contasRecebidasRel} />
      </div>
    </div>
    <div className="" style={{ width: '30%', border: '3px solid #FF6347' }} > 
      <div className="card-body" >
        <h5 className="card-title">Total Pendente</h5>
        <p className="card-text">{totalPendente}</p>
        <button onClick={openModalPendentes} className="card-text btn">Explorar</button>
        <ModalDreContasPendentes isOpen={isModalPendentesOpen} onClose={closeModalPendentes} contasPendentes={contasPendentesRel} />
      </div>
    </div>
  </div>

  <div style={{ marginBottom: '40px' }}>
    {dadosGraficoOperacoes.labels.length > 0 && dadosGraficoOperacoes.datasets.length > 0 && (
      <>
       
        <div className="chart-container">
          <Bar
            data={{
              labels: dadosGraficoOperacoes.labels,
              datasets: [
                {
                  
                  label: 'Total de Emissões',
                  backgroundColor: '#007FFF',
                  data: dadosGraficoOperacoes.datasets[2]?.data || [], 
                },
              ],
            }}
            options={{
              ...options,
              responsive: true,
              maintainAspectRatio: false, 
            }}
          />
        </div>

     
        <div className="chart-container">
          <Bar
            data={{
              labels: dadosGraficoOperacoes.labels,
              datasets: [
                {
                  label: 'Contas Recebidas',
                  backgroundColor: '#00FF00',
                  data: dadosGraficoOperacoes.datasets[0]?.data || [], 
                },
              ],
            }}
            options={{
              ...options,
              responsive: true,
              maintainAspectRatio: false, 
            }}
          />
        </div>

      
        <div className="chart-container">
          <Bar
            data={{
              labels: dadosGraficoOperacoes.labels,
              datasets: [
                {
                  label: 'Contas Não Recebidas',
                  backgroundColor: '#FF6347',
                  data: dadosGraficoOperacoes.datasets[1]?.data || [], 
                },
              ],
            }}
            options={{
              ...options,
              responsive: true,
              maintainAspectRatio: false, 
            }}
          />
        </div>
      </>
    )}
  </div>
</div>


          <hr />

         
          <div>
          <h2>Finalizadoras</h2>
          </div>
          <div className="d-flex justify-content-center mb-5">
          
            <div className="card" style={{ width: '30%' }}>
              <div className="card-body">
                <h5 className="card-title">Total de Vendas</h5>
                <p className="card-text">{totalVendas.toLocaleString('pt-BR', {
                                           style: 'currency',
                                           currency: 'BRL',
                                           minimumFractionDigits: 2,
                                           maximumFractionDigits: 2
                                           })}</p>
              
              </div>
            </div>
           
            <div className="card ml-5" style={{ width: '30%' }}>
              <div className="card-body">
                <h5 className="card-title">Ticket Médio</h5>
                <p className="card-text">{ticketMedio.toLocaleString('pt-BR', {
                                          style: 'currency',
                                          currency: 'BRL',
                                          minimumFractionDigits: 2,
                                          maximumFractionDigits: 2
                                          })}</p>
                
              </div>
            </div>
          </div>

          <div style={{ marginBottom: '40px' }}>
           <Bar data={dadosGraficoFinalizadoras} options={optionsGraficoFinalizadoras} />
           </div>

          <hr />

          <div>
  <h2>Promissórias</h2>
</div>
<div className="d-flex justify-content-between mb-5">
  
  <div className="card" style={{ width: '30%', border: '3px solid #007FFF' }}>
    <div className="card-body">
      <h5 className="card-title">Total de Promissórias</h5>
      <p className="card-text">
        {totalPromissorias.toLocaleString('pt-br' , {style: 'currency', currency: "BRL"})}
      </p>
    
    </div>
  </div>

  
  <div className="card"  style={{ width: '30%' , border: '3px solid #00FF00' }} >
    <div className="card-body">
      <h5 className="card-title">Promissórias Pagas</h5>
      <p className="card-text">
        {totalPromissoriasPago.toLocaleString('pt-br' , {style: 'currency', currency: "BRL"})}
      </p>
     
    </div>
  </div>

  
  <div className="card" style={{ width: '30%', border: '3px solid #FF6347' }}>
    <div className="card-body">
      <h5 className="card-title">Promissórias Pendentes</h5>
      <p className="card-text">
        {totalPromissoriasPendente.toLocaleString('pt-br' , {style: 'currency', currency: "BRL"})} 
      </p>
      
    </div>
  </div>
</div>


<div style={{ marginBottom: '40px' }}>
  <Bar data={dadosGraficoPromissorias} options={optionsGraficoPromissorias} />
</div>


        </div>
      </div>
      <FooterBar />
    </div>
  );
}

export default DreDashboard;





